const jasonImages = [
  { src: "/jasons/aquaman.png", alt: "aquaman" },
  { src: "/jasons/drogo.png", alt: "khal drogo" },
  { src: "/jasons/voss.png", alt: "baba voss" },
  { src: "/jasons/garrett.png", alt: "garrett" },
  { src: "/jasons/idaho.png", alt: "duncan idaho" },
  { src: "/jasons/dante.png", alt: "dante" },
  { src: "/jasons/conan.png", alt: "conan the barbarian" },
  { src: "/jasons/kaiana.png", alt: "kaiana" },
  { src: "/jasons/momoa.png", alt: "jason momoa" },
];

module.exports = { jasonImages };
